(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nav-mobile"]) return;
  try {
    

$(function(){

  var accordion_head = $('.accordion > li > a'),
      accordion_sub  = $('.accordion li > .mobile-sub-menu'),
      nav_head       = $('li.mobile-drop > a'); 

  accordion_head.on('click', function(e){
    console.log('click');
    e.preventDefault();
    if (!$(e.target).hasClass('active')){
        $('.accordion > li > a').removeClass('active');
        $('.accordion li > .mobile-sub-menu').slideUp();
        $(this).addClass('active').closest('li').find('.mobile-sub-menu').slideDown();    
    } else {
        $('.accordion > li > a').removeClass('active');      
        $('.accordion li > .mobile-sub-menu').slideUp();
      
    }
  });

  
  /*
  nav_head.on('click', function(e){
    e.preventDefault();
    $('.accordion > li').eq( $(this).closest('li').index()-1 ).find('a').click();
  });
*/


});


  } catch(e) { console.error(e); }
})();
})();
